
const roles = {
    levelAdmin: { title: "Level finance admin", id: "5d8e0b079f51d42bbece9201" },
    levelEmployee: { title: "Employee", id: "5d8e0b079f51d42bbece9202" },
    levelEmployerAdmin: { title: "Employer admin", id: "62bd55b7c5793941427c702d" },
}

export default roles